import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import './RecommendSearchWordSaveNavbar.scss';

const RecommendSearchWordSaveNavbar = (props) => {
  const { onSubmit } = props;

  return (
    <FixedBottomNavBar className="recommend-search-word-save-navbar">
      <div className="button-group">
        <Button color="primary" text="등록하기" onClick={onSubmit} />
      </div>
    </FixedBottomNavBar>
  );
};

export default RecommendSearchWordSaveNavbar;
